export const fadeInMixin = (delay) => ({
    animation: `fadeIn 0.5s`,
    animationDelay: delay ? `${delay}s` : '0s',
    animationFillMode: 'forwards',
    opacity: 0,
})